import React, {useState, useContext, useEffect} from 'react';
import { CircularProgress, Avatar, Button, CssBaseline, TextField, Link, Box, Typography, Container, Backdrop } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Context } from '../App';
import { useParams, useNavigate } from 'react-router-dom';
import fond1 from '../assets/fond1.png';
import Footer from "../components/layout/Footer";


export default function ResetPwd() {
    const { token } = useParams()
    const navigate = useNavigate()
    const [loading, setLoad] = useState(true)
    const [isExpired, setExpired] = useState(false)
    const [success, setSuccess] = useState(false);

    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const [passwordError, setPasswordError] = React.useState('');
    const [msg, setMsg] = React.useState('');
    

    const handleSubmit = (event) => {
        event.preventDefault();

        if (password===confirmPassword&&password.length>=6) {
            setLoad(true)
            fetch(process.env.REACT_APP_API_URL.concat('/users/set-pwd'), {
                method: 'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(token+':'+password),
                },
            }).then(async(response)=> {
                if(response.status === 401) {
                    setExpired(true); setLoad(false)
                }else if (response.status === 200) {
                    setSuccess(true);
                    setLoad(false);
                    setTimeout(() => {
                        navigate('/connexion') 
                    }, 5000);
                }else{
                    setMsg("Erreur! impossible d'enregistrer le nouveau mot de passe\n veuillez réessayer ultérieurement ou contacter votre administrateur.")
                    setLoad(false)
                }
            })
        } else setMsg(password!==confirmPassword ? 'Attention! les mots de passe sont différents.' : 'Mot de passe trop court.\n Le mot de passe doit contenir 6 caractères minimums.')
    };

    useEffect(()=>{
        fetch(process.env.REACT_APP_API_URL.concat('/check_token'), {method:'HEAD', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }}).then(response=>{
            setExpired(!!!response.ok)
            setLoad(false)
            if (!response.ok) {
                throw new Error(response.statusText);
            } 
        }).catch(err=>{
            console.error('Erreur lors de la vérification du token:', err);
            setExpired(true);
            setLoad(false);
        })
    }, [])

    return (
    (isExpired && !loading) ?
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, pt:10 }}>
        <img src={require('../assets/logo-no-bg.png')} alt="Logo" style={{ width: '150px', margin: '20px auto' }} />
        <Typography variant="body1" align="center" sx={{ mt: 2, mb:7, fontSize:24, fontWeight:500, fontStyle:'italic', color: 'primary.main' }}>
            Oups, ce lien est arrivé à expiration.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/connexion')} sx={{ mb: 2 }}>
            Retour à la connexion
        </Button>
    </Box>
    :
    (success && !loading) ?
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, pt:10 }}>
        <img src={require('../assets/check.png')} alt="Logo" style={{ width: '150px', margin: '20px auto' }} />
        <Typography variant="body1" align="center" sx={{ mt: 2, mb:7, fontSize:24, fontWeight:500, fontStyle:'italic', color: 'primary.main' }}>
            Votre mot de passe a été modifié avec succès! <br/>Vous allez être redirigé vers la page de connexion.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/connexion')} sx={{ mb: 2 }}>
            Retour à la connexion
        </Button>
    </Box>
    :
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundImage: `url(${fond1})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '100vh' }}>
        <Box sx={{ flexGrow: 1, px: 3 }}>
            <img src={require('../assets/logo-no-bg.png')} alt="Logo" style={{ width: '150px', margin: '20px auto', display: 'block' }} />

            <Container component='form' onSubmit={handleSubmit} maxWidth='sm' sx={{ display:'flex', flexDirection:'column', minWidth: '300px', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: 3, borderRadius: 2, gap:2 }}>
                <Typography variant="h4" align="center" sx={{ mt:4, mb:2 }}> Modification du mot de passe</Typography>

                { msg && <Typography variant="body1" color="error" sx={{ mb: 1, mt: -2, fontSize:14, fontWeight: 600, fontStyle:'italic', textAlign:'center' }}>{msg}</Typography>}

                <TextField fullWidth type="password" label="Nouveau mot de passe" variant="outlined" required value={password}
                onChange={(e) => setPassword(e.target.value)} />
                <TextField fullWidth type="password" label="Confirmer le mot de passe" variant="outlined" required error={!!passwordError} value={confirmPassword}
                helperText={passwordError} onChange={(e) => setConfirmPassword(e.target.value)} sx={{ mb: 4 }} />
                

                <Button type="submit" variant="contained" disabled={password.length < 6 } color="primary" sx={{alignSelf: 'center', px: 5, mb: 2}}>Enregistrer</Button>

                <Backdrop open={loading}><CircularProgress/></Backdrop>

            </Container>

        </Box>
        <Footer {...{color: 'rgba(255,255,255,0.8)'}}/>
    </Box>
    );
}